import React from 'react';
import { Steps } from 'antd';
import { useSignUp } from '../context/SignUpContext';

const ProgressHeader = () => {
  const { currentStep, formData } = useSignUp();

  // Define steps based on account type
  // For SELLER_PF, we skip the company step
  const isPJ = formData.accountType === 'SELLER_PJ';

  const getSteps = () => {
    const baseSteps = [
      { title: 'Conta' },
      { title: 'Tipo' },
      { title: 'Pessoal' },
      { title: 'Endere\u00e7o' },
      { title: 'Neg\u00f3cio' },
      { title: 'Banco' },
    ];

    if (isPJ) {
      baseSteps.push({ title: 'Empresa' });
    }

    baseSteps.push({ title: 'Revis\u00e3o' });

    return baseSteps;
  };

  const steps = getSteps();

  // Calculate visual step for display (accounting for skipped company step in PF)
  const getVisualStep = () => {
    if (!isPJ && currentStep > 5) {
      // For PF, after bank step (5), skip to review (which is visual step 6)
      return currentStep - 1;
    }
    return currentStep;
  };

  return (
    <div className="progress-header">
      <Steps
        current={getVisualStep()}
        size="small"
        items={steps}
        responsive={false}
      />
    </div>
  );
};

export default ProgressHeader;
